import { render } from "./SelectorH1.vue?vue&type=template&id=a8f5b3fa"
import script from "./SelectorH1.vue?vue&type=script&lang=js"
export * from "./SelectorH1.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__